import { ConfigProvider, App as AntdApp } from "antd";
import enUS from "antd/locale/en_US";
import { BrowserRouter } from "react-router";

import { LanguageProvider } from "@/contexts/LanguageContext";
import { antdTheme } from "@/theme/antdTheme";

import { AppRouter } from "@/router/AppRouter";

export default function App() {
  return (
    <ConfigProvider locale={enUS} theme={antdTheme}>
      <AntdApp>
        <LanguageProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </LanguageProvider>
      </AntdApp>
    </ConfigProvider>
  );
}
